import { isValidSelectorString } from '@/utils/validations/selector.validation';
import { z } from 'zod';
import { MarginRateSchema } from '../common/margin-rate.schema';

export const ClientContactSchema = z.object({
  firstName: z.string({ message: 'Le prénom est obligatoire' }),
  lastName: z.string({ message: 'Le nom est obligatoire' }),
  email: z
    .string({ message: "L'email doit être valide" })
    .email({ message: "L'email doit être valide" })
    .optional(),
  phoneNumber: z
    .string()
    .regex(
      /^\+?[0-9]+$/,
      'Le numéro de téléphone ne doit contenir que des chiffres ou un + au début',
    )
    .min(5, 'Le numéro de téléphone doit contenir au moins 5 caractères')
    .or(z.literal(''))
    .optional(),
});

export const ClientSchema = z.object({
  agencyName: z.string().optional(),
  mainContact: ClientContactSchema,
  secondaryContacts: z.array(ClientContactSchema),
  address: z.string().optional(),
  city: z.string().optional(),
  postalCode: z.coerce.number().int().min(0, 'Code postal invalide').optional(),
  country: isValidSelectorString('Le pays est requis').optional(),
  marginRate: MarginRateSchema.optional(),
  reservationAgent: isValidSelectorString("L'agent de réservation est requis"),
});

export type ClientFormData = z.infer<typeof ClientSchema>;

export const getClientSchema = (isTourOperator: boolean) =>
  ClientSchema.superRefine((data, ctx) => {
    if (isTourOperator && !data.agencyName?.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Le nom de l'agence est obligatoire",
        path: ['agencyName'],
      });
    }
    // Pour un tour-opérateur, l'email de l'agence est obligatoire (il sert à lui
    // transmettre le lien AGENCY du devis).
    if (isTourOperator && !data.mainContact?.email?.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "L'email est obligatoire",
        path: ['mainContact', 'email'],
      });
    }
  });
